// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2GZsY","errorLogs":"styles_errorLogs__1TbEj"};